module.exports = __webpack_public_path__ + "static/img/bg-fr.a3131345.png";